// extracted by mini-css-extract-plugin
var _1 = "NotFoundView-module__container--ddDIz";
export { _1 as "container" }
